import SfAccordionConnected from '@app/shared/vue/connected/sf-accordion.vue'
import SfDropdown from '@app/shared/vue/components/sf-dropdown/sf-dropdown.vue'
import SfDropdownConnected from '@app/shared/vue/connected/sf-dropdown.vue'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import SfInputConnected from '@app/shared/vue/connected/sf-input.vue'

export default [
  ['sf-accordion-connected', { component: SfAccordionConnected }],
  ['sf-dropdown', { component: SfDropdown }],
  ['sf-dropdown-connected', { component: SfDropdownConnected }],
  ['sf-dropdown-item', { component: SfDropdownItem }],
  ['sf-input', { component: SfInputConnected }],
]
